module.exports = ".text-left {\r\n  float: right;\r\n}\r\n.btn-group .btn {\r\n  min-width: 5px;\r\n}\r\n.btn-group i {\r\n  color: white;\r\n}\r\n/* .model-dialog {\r\n  z-index: 1040;\r\n}\r\n.modal-content {\r\n  z-index: 1100;\r\n} */\r\n.col-xs-4 {\r\n  width: 33.33%;\r\n  float: left;\r\n  position: relative;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/Pages/tasks/book-appointment/book-appointment-form/book-appointment-form.component.css
// module id = ./src/app/Pages/tasks/book-appointment/book-appointment-form/book-appointment-form.component.css
// module chunks = main